/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import CENArrowRightLong from "@tCentro/Icons/CENArrowRightLong";
import CENHomeArrowRightFirst from "@tCentro/Icons/CENHomeArrowRightFirst";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    return {
        recentWishListsDataView: getWishListsDataView(state, recentWishListsParameter),
        myListsPageNavLink: getPageLinkByPageType(state, "MyListsPage"),
        canViewWishLists: (session.isAuthenticated || session.rememberMe) && !session.isGuest,
    };
};

let recentWishListsParameter = {
    page: 1,
    sort: "ModifiedOn DESC",
    expand: ["top3products", "favorite", "hidden", "tags"],
} as GetWishListsApiParameter;

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface MyListCardListHeadingStyles {
    buttonOne: ButtonPresentationProps;
    headingDiv: InjectableCss;
    iconOne: IconPresentationProps;
    gridMainItem: InjectableCss;
    cardListHeading: InjectableCss;
    allListLink: InjectableCss;
}

export const myListCardListHeadingStyles: MyListCardListHeadingStyles = {
    buttonOne: {
        variant: "secondary",
        css: css`
            border-radius: 16px;
            font-family: "Poppins";
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            padding: 8px 12px 8px 16px;
            gap: 4px;
            display: flex;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        border-radius: 12px;
                        padding: 4px 8px 4px 12px;
                        gap: 2px;
                        font-size: 11px;
                        line-height: 12px;
                    `,
                    css`
                        border-radius: 12px;
                        padding: 4px 8px 4px 12px;
                        gap: 2px;
                        font-size: 11px;
                        line-height: 12px;
                    `,
                    css`
                        border-radius: 14px;
                        padding: 6px 10px 6px 14px;
                        gap: 3px;
                        font-size: 13px;
                        line-height: 14px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    headingDiv: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin-top: 38px;
            div {
                align-items: center;
                justify-content: space-between;
                margin: 0px 24px 0px 10px;
            }
        `,
    },
    iconOne: {
        size: 16,
        css: css`
            svg {
                > path {
                    fill: ${getColor("text.link")};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 12px;
                        height: 12px;
                    `,
                    css`
                        width: 12px;
                        height: 12px;
                    `,
                    css`
                        width: 14px;
                        height: 14px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    gridMainItem: {
        css: css`
            padding-bottom: 0px;
        `,
    },
    cardListHeading: {
        css: css`
            dispaly: flex;
            justify-content: space-between;
        `,
    },
    allListLink: {
        css: css`
            span {
                display: flex;
                align-items: center;
                font-weight: 600;
                font-size: 14px;
                line-height: 16px;
            }
        `,
    },
};
const styles = myListCardListHeadingStyles;
const MyListCardListHeading: React.FunctionComponent<Props> = ({ heading, viewAllUrl, recentWishListsDataView }) => {
    const handleClick = () => {
        if (viewAllUrl) {
            window.location.href = viewAllUrl;
        }
    };

    const recentWishLists: any[] = recentWishListsDataView.value ?? [];

    return (
        <GridItem width={12} {...styles.gridMainItem}>
            <GridContainer
                offsetCss={css`
                    // border-bottom: 1px solid ${getColor("common.border")};
                    // padding-top: 40px;
                    &&& {
                        width: 100%;
                    }
                `}
                {...styles.headingDiv}
            >
                <StyledWrapper {...styles.cardListHeading}>
                    <Typography className="card-list-heading" variant="h2">
                        {heading}
                    </Typography>
                </StyledWrapper>
                {viewAllUrl && recentWishLists.length > 0 && (
                    <Link href={viewAllUrl} {...styles.allListLink}>
                        {translate("All Lists")}
                        <Icon src={CENArrowRightLong} {...styles.iconOne} />
                    </Link>
                )}
            </GridContainer>
        </GridItem>
    );
};

export default MyListCardListHeading;
